import { render, staticRenderFns } from "./HeaderMessage.vue?vue&type=template&id=d7bb6fa2&scoped=true&"
import script from "./HeaderMessage.vue?vue&type=script&lang=js&"
export * from "./HeaderMessage.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMessage.vue?vue&type=style&index=0&id=d7bb6fa2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7bb6fa2",
  null
  
)

export default component.exports